import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { message, Spin } from 'antd';
import api from '../api/client';
import { useAppStore } from '../store/appStore';

export default function TgLogin() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const setToken = useAppStore((state) => state.setToken);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      message.error('Нет токена авторизации');
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post('/auth/telegram/consume', { token });
        setToken(res.data.token);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        message.error(err?.response?.data?.error || 'Не удалось авторизоваться');
        navigate('/login', { replace: true });
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate, params]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-surface rounded-2xl border border-white/5 p-8 text-center">
        <div className="text-white text-lg font-semibold mb-3">Авторизация</div>
        {loading ? (
          <div className="flex flex-col items-center gap-4">
            <Spin />
            <div className="text-slate-400 text-sm">Проверяем токен...</div>
          </div>
        ) : (
          <div className="text-slate-400 text-sm">Готово</div>
        )}
      </div>
    </div>
  );
}

